import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import './MyApps.scss';
import TablePaginationNew from '../../../common/Pagination/TablePaginationNew';
import EditOrCreateApplication from './EditOrCreateApplication/EditOrCreateApplication';
import Loader from '../../../common/base/Loader/Loader';
import { setLoader, fetchApplicationsList, resetSecretApplication, deleteApplicationDetail, fetchOwnersList, addOwner, removeOwner } from '../../actions';
import {default as copyText} from '../../../common/utility/copyText';
import { useToast } from '../../../common/base/ToastContext';
import { TEXT_PATTERN } from '../../../common/base/constants';
import {API_BASE_PATH, commonHeaders} from '../../actions/constants';
import CopyTexttoClipBrd from '../../../common/base/CopyTexttoClipBrd/CopyTexttoClipBrd';
import { getPropTypeLabel } from '../../../common/utility/utils';
import RequestStatusBadge from '../../../common/base/RequestStatusBadge/RequestStatusBadge';
import CommonConfiramation from '../../../common/base/CommonConfiramation/CommonConfiramation';
import Modal from 'react-bootstrap/Modal';
import { useCombined } from '../../../common/base/CombinedContext';


const MyApps = ({ selected, config, items, ...props }) => { 
    const resolvedGatewayName = config?.gatewayName?.trim() ? config.gatewayName : 'Flex';
    const resolvedAuthProvider = config?.authProvider?.trim() ? config.authProvider : 'Okta';
    const [applications, setApplications] = useState([]);
    const [error, setError] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);
    const [hiddenStates, setHiddenStates] = useState([]);
    const [showCopyStates, setShowCopyStates] = useState([]);
    const [showCopy, setShowCopy] = useState({client_id: true, client_secret: true});
    const [showCopyStatesSecret, setShowCopyStatesSecret] = useState([]);
    const [hideText, setHideText] = useState(true);
    const [dropdownVisible, setDropdownVisible] = useState([]);
    const [showModal, setShowModal] = useState({ edit: false, reset: false, apis: false, delete: false, resetConfirmation: false, deleteConfirmation: false, owners: false, deleteOwner: false, editContract: false, deleteContract: false });
    const grantTypes = ['Authorization Code Grant', 'Client Credential Grant', 'Resource Owner Grant', 'Implicit Grant', 'Refresh Token'];
    const [currentApplication, setCurrentApplication] = useState(null);
    const [appIdForModal, setAppIdForModal] = useState(null);
    const [loading, setLoading] = useState(false);
    const [popupData, setPoupupData] = useState({title: "", message: "", status: "", showAlert: false});
    
    const [newOwnerCcoId, setNewOwnerCcoId] = useState('');
    const [ownerCcoIdError, setOwnerCcoIdError] = useState('');
    const [newAddedOwners, setNewAddedOwners] = useState([]);
    const [deletedOwners, setDeletedOwners] = useState([]);
    const [initialOwners, setInitialOwners] = useState([]);
    const [primaryOwner, setPrimaryOwner] = useState('');
    const [deleteId, setDeleteId] = useState(null);
    const [errorOnSaveOwners, setErrorOnSaveOwners] = useState('');
    const [successOnSaveOwners, setSuccessOnSaveOwners] = useState('');
    const [selectedContract, setSelectedContract] = useState(null);
    const [contractSlaTiers, setContractSlaTiers] = useState([]);
    const [contractSlaTiersLoading, setContractSlaTiersLoading] = useState(false);

    const [formValues, setFormValues] = useState({
        clientAppName: '',
        clientAppDescription: '',
        applicationURL: '',
        grantTypes: [],
        redirectUris: ['']
    });
    const [tableConfig, setTableConfig]= useState({
        pageSize: 10,
        totalPages: 0,
        totalRecords:0,
        currentPage:1,
        pageLimit: [10, 15, 20]
      });
    const [searchTerm, setSearchTerm] = useState('');
    const apiGrantTypesToFormValues = {
        'authorization_code': 'Authorization Code Grant',
        'client_credentials': 'Client Credential Grant',
        'resource_owner_credentials': 'Resource Owner Grant',
        'implicit': 'Implicit Grant',
        'refresh_token': 'Refresh Token'
    };
    const otherGateways = [
        {
            title: "Mulesoft",
            ref: "mulesoft",
            img: "mulesoft-logo.png",
            url: "https://anypoint.mulesoft.com/exchange/applications/"
        },
        {
            title: "Cisco API Console",
            ref: "cisco-api-console",
            img: "mashery-logo.png",
            url: "https://apiconsole.cisco.com/apps/myapps"
        }
    ]
    const dropdownRefs = useRef([]);
    const reopenApisRef = useRef(false);

    const breadcrumbItems = [{
        title:"Cisco IT APIs",
        url:"/"
      },
      {
        title:"My Apps",
        url:""
      }]

    const { setBreadcrumbItems } = useCombined();
    useEffect(() => {
      if(!config) setBreadcrumbItems(breadcrumbItems);
    }, [setBreadcrumbItems]);

    const handleClose = (modal) => {
        setShowModal(prev => ({ ...prev, [modal]: false }))
        if (modal === 'edit') {
            setPoupupData({title: "", message: "", status: "", showAlert: false});
        }
    };
    
    const handleShowModal = async (modal, appId, contractData) => {
        setShowModal(prev => ({ ...prev, [modal]: true }))
        let selectedApp = null;
        if (modal === "deleteOwner") {
            setDeleteId(appId);
        } else if (modal === 'editContract' || modal === 'deleteContract') {
            setSelectedContract(contractData);
            setAppIdForModal(appId);
        } else {
            setAppIdForModal(appId);
            const app = applications.find(app => app.id === appId);
            const uppercaseGrantTypes = app?.grantTypes.map(type => type.toUpperCase());                
            selectedApp = {
                ...app,
                grantTypes: uppercaseGrantTypes,
            };
            setCurrentApplication(selectedApp);
        }
        
        if (modal === 'edit') {
            setPoupupData({title: "", message: "", status: "", showAlert: false});
            setFormValues({
                clientAppName: selectedApp?.name || '',
                clientAppDescription: selectedApp?.description || '',
                applicationURL: selectedApp?.url || '',
                grantTypes: selectedApp?.grantTypes ? selectedApp.grantTypes : [],
                redirectUris: selectedApp?.redirectUri || []
            });
        }
        if (modal === 'deleteConfirmation') {
            handleClose("delete");
        }
    };

    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';

    const fetchSlaTiers = async (api) => {
        setContractSlaTiers([]);
        setContractSlaTiersLoading(true);
        try {
            const contractId = api?.contractId;
            if (!contractId) {
                console.log('[fetchSlaTiers] missing contractId, skipping API call');
                return;
            }
            const gateway = api?.gateway || resolvedGatewayName;
            const res = await axios.get(
                `${API_BASE_PATH}/accessRequests/${contractId}/tiers?gateway=${gateway}`
            );
            setContractSlaTiers(res.data || []);
        } catch (err) {
            showToast({ title: 'Error', bg: 'danger', message: 'Failed to fetch SLA tiers' });
        } finally {
            setContractSlaTiersLoading(false);
        }
    };

    const openEditContractModal = (appId, api) => {
        handleClose('apis');
        setSelectedContract(api);
        setAppIdForModal(appId);
        setShowModal(prev => ({ ...prev, editContract: true }));
        fetchSlaTiers(api);
    };

    const handleBackToApis = () => {
        handleClose('editContract');
        handleClose('deleteContract');
        setShowModal(prev => ({ ...prev, apis: true }));
    };

    const handleEditContract = async (submitValue) => {
        const contractId = selectedContract?.contractId;
        if (!contractId) {
            showToast({ title: 'Error', bg: 'danger', message: 'No contract selected for editing' });
            return;
        }
        const { newSlaTierId, reason } = submitValue || {};
        if (!newSlaTierId) {
            showToast({ title: 'Error', bg: 'danger', message: 'Please select a new SLA tier' });
            return;
        }
        try {
            setLoading(true);
            const response = await axios.patch(
                `${API_BASE_PATH}/accessRequests/${contractId}/client-edit-tier`,
                { newSlaTierId, reason }
            );
            const msg = response?.data?.message || 'SLA tier updated successfully';
            showToast({ title: 'Success', bg: 'success', message: msg });
            handleClose('editContract');
            reopenApisRef.current = true;
            fetchApplications();
        } catch (err) {
            showToast({ title: 'Error', bg: 'danger', message: 'Failed to update SLA tier' });
            setLoading(false);
        }
    };

    const handleClientDeleteContract = async () => {
        const contractId = selectedContract?.contractId;
        if (!contractId) {
            showToast({ title: 'Error', bg: 'danger', message: 'No contract selected for deletion' });
            return;
        }
        try {
            setLoading(true);
            await axios.delete(
                `${API_BASE_PATH}/accessRequests/${contractId}/client-delete`
            );
            showToast({ title: 'Success', bg: 'success', message: 'Contract removed successfully' });
            handleClose('deleteContract');
            reopenApisRef.current = true;
            fetchApplications();
        } catch (err) {
            showToast({ title: 'Error', bg: 'danger', message: 'Failed to delete contract' });
            setLoading(false);
        }
    };

    const { showToast } = useToast();

    useEffect(() => {
        fetchApplications();
    }, [props.refetchApplication]);

    useEffect(() => {
    console.log("props.errorResponseApps == ",props.errorResponseApps);
        if (props.errorResponseApps?.status == false) {
            setError(props.errorResponseApps?.data);
            showToast({
                title: 'Operation Failed',
                bg: 'danger',
                message: props.errorResponseApps?.data,
            });
            setLoading(false);
        }
    }, [props.errorResponseApps, props.response])

    useEffect(() => {
        if (props.applicationList.data) {
            let data = props.applicationList.data;
            setApplications(data.clients);
            setHiddenStates(Array(data.clients.length).fill(true));
            setShowCopyStates(Array(data.clients.length).fill(true));
            setShowCopyStatesSecret(Array(data.clients.length).fill(true));
            setDropdownVisible(Array(data.clients.length).fill(false));
            setTableConfig({
                ...tableConfig,
                totalPages: data.totalPages,
                totalRecords: data.totalRecords
            });
            if (currentApplication) {
                const updated = data.clients.find(c => c.id === currentApplication.id);
                if (updated) {
                    setCurrentApplication(updated);
                }
            }
            if (reopenApisRef.current) {
                reopenApisRef.current = false;
                setShowModal(prev => ({ ...prev, apis: true }));
            }
            setLoading(false);
            setError(null);
        }
    
      }, [props.applicationList])

      useEffect(() => {
        if (props.deleteResponse.data) {
            fetchApplications();
            setLoading(false);
            handleClose('deleteConfirmation');
            showToast({
                title: 'Operation Successful',
                bg: 'success',
                message: 'Application deleted successfully!',
            });
        }

      }, [props.deleteResponse]);

      useEffect(() => {
        if (props.resetResponse?.data) {
            fetchApplications();
        }
      }, [props.resetResponse]);

      function showResetConfirmation(data) {
        setLoading(false);
        if (data) {
            setCurrentApplication(prevValue => ({...prevValue, clientSecret: data.clientSecret}));
            handleClose('reset');
            setShowModal(prev => ({ ...prev, resetConfirmation: true }));
        }
      }

    function handleResetSecretError(errorData) {
        const errorMessage = errorData?.error || errorData?.message || errorData || 'Failed to reset client secret';
        setLoading(false);
        showToast({
                title: 'Operation Failed',
                bg: 'danger',
                message: errorMessage,
        });
    }
      
      

    const fetchApplications = async () => {
        setLoading(true);
        const organizationId = config?.organizationId || null;
        const gateway = resolvedGatewayName;
        const authType = resolvedAuthProvider;
        const assetId = config?.assetId || null;
        const versionGroup = config?.versionGroup || null;
        props.dispatch(fetchApplicationsList(organizationId, gateway, authType, tableConfig.currentPage, tableConfig.pageSize, searchTerm, assetId, versionGroup));
        
    };

    const updateApplication = async (appId, gateway, authType, updatedData) => {
        setPoupupData({title: "", message: "", status: "", showAlert: false});
        const addOrganizationId = config?.organizationId ? `/organizations/${config?.organizationId}` : '';
        const resolvedGateway = config?.gatewayName?.trim() ? config.gatewayName : (gateway?.trim() ? gateway : 'Flex');
        const resolvedAuthType = config?.authProvider?.trim() ? config.authProvider : (authType?.trim() ? authType : 'Okta');
        const queryParams = new URLSearchParams({
            gateway: resolvedGateway,
            authType: resolvedAuthType,
        });
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_PATH}${addOrganizationId}/applications/${appId}?${queryParams.toString()}`, {
                method: 'PATCH',
                body: JSON.stringify(updatedData),
                headers: commonHeaders,
            });

            const contentType = response.headers.get('Content-Type');
            const isJson = contentType?.includes('application/json');
            if (!response.ok) {
                setLoading(false);
                const errorData = isJson ? await response.json() : await response.text();
                const errorMessage = errorData.error || 'Failed to update application';
                throw new Error(errorMessage);
            } else {
                const data = await response.json();       
                await fetchApplications();
                setLoading(false);
                handleClose('edit');
                showToast({
                    title: 'Operation Successful',
                    bg: 'success',
                    message: 'Application updated successfully!',
                });
                //updateExpendedRow();
                return data;
            }
        } catch (error) {
            setError(error.message);
            setPoupupData({title: "Request Failed", message: `${error.message}`, status: "danger", showAlert: true});
        }
    };

    const mapFormValuesToApiGrantTypes = (data) => {
        return {
            ...data,
            grantTypes: data.grantTypes.map(apiGrantType => apiGrantTypesToFormValues[apiGrantType] || apiGrantType),
        };
    }

    const resetSecret = async (appId) => {
        setLoading(true);
        const organizationId = config?.organizationId || null;
        const gateway = config?.gatewayName?.trim() ? config.gatewayName : (currentApplication?.gateway?.trim() ? currentApplication.gateway : 'Flex');
        const authType = config?.authProvider?.trim() ? config.authProvider : (currentApplication?.authType?.trim() ? currentApplication.authType : 'Okta');
        props.dispatch(resetSecretApplication(organizationId, gateway, authType, appId, showResetConfirmation, handleResetSecretError));
    };

    const deleteApplication = async (appId) => {
        setLoading(true);
        const organizationId = config?.organizationId || null;
        const gateway = config?.gatewayName?.trim() ? config.gatewayName : (currentApplication?.gateway?.trim() ? currentApplication.gateway : 'Flex');
        const authType = config?.authProvider?.trim() ? config.authProvider : (currentApplication?.authType?.trim() ? currentApplication.authType : 'Okta');
        props.dispatch(deleteApplicationDetail(organizationId, gateway, authType, appId));
    };

    const toggleRow = async (index, appId) => {
        if (expandedRow === index) {
            setExpandedRow(null);
        } else {
            setExpandedRow(index);
            setCurrentApplication(applications[index]);
            //getApplication(appId);
        }
    };

    const toggleClass = (index) => {
        setHiddenStates(prevHiddenStates => {
            const newHiddenStates = [...prevHiddenStates];
            newHiddenStates[index] = !newHiddenStates[index];
            return newHiddenStates;
        });
    };

    const toggleDropdown = (index) => {
        setDropdownVisible(prevVisibility => {
            const newVisibility = [...prevVisibility];
            newVisibility[index] = !newVisibility[index];
            return newVisibility;
        });
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    const handleSearch = () => {
        let dumConfig = tableConfig;
        dumConfig.currentPage = 1;
        setTableConfig(dumConfig);
        fetchApplications();
    };

    const handleSearchTermChange = (e) => {
        const { value } = e.target;
        if (TEXT_PATTERN.test(value) || value === '') {
            setSearchTerm(value);
        }
    };
    

    // Handle page change
    const handlePageChange = (pageNumber) => {
        let dumConfig = tableConfig;
        dumConfig.currentPage = pageNumber;
        setTableConfig(dumConfig);
        fetchApplications();
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (newRowsPerPage) => {
        let dumConfig = tableConfig;
        dumConfig.currentPage = 1;
        dumConfig.pageSize = newRowsPerPage;
        setTableConfig(dumConfig);
        fetchApplications();
    };

    const modals = {
        reset: {
            title: 'Reset Client Secret',
            body: 'Are you sure you want to reset the selected client secret?',
            footerButtons: {
                cancel: { text: 'Close', variant: 'secondary', onClick: () => handleClose('reset') },
                ok: { text: 'Yes, reset secret', variant: 'primary', onClick: () => resetSecret(appIdForModal) }
            }
        },
        delete: {
            title: 'Delete Application',
            body: 'Are you sure you want to delete this application?',
            footerButtons: {
                cancel:{ text: 'Close', variant: 'secondary', onClick: () => handleClose('delete') },
                ok: { text: 'Yes, Delete', variant: 'danger', onClick: () => { handleShowModal('deleteConfirmation', appIdForModal) } }
            }
        },
        deleteConfirmation: {
            title: 'Warning!',
            body: 'This may impact existing client app if they are using same client id and secret',
            footerButtons: {
                cancel:{ text: 'Close', variant: 'secondary', onClick: () => handleClose('deleteConfirmation') },
                ok: { text: 'Confirm Delete', variant: 'danger', onClick: () => { deleteApplication(appIdForModal) } }
            }
        },
        resetConfirmation: {
            title: 'Successfully Generated Client Secret',
            body: "",
            footerButtons: {
                cancel: { text: 'Close', variant: 'primary', onClick: () => handleClose('resetConfirmation') }
            },
            data: {
                client_id: currentApplication?.clientId,
                client_secret: currentApplication?.clientSecret
            }
        },
        apis: {
            title: 'Associated APIs and status',
            body: (
                <table className="table mt-2 mb-5 associated-table iap-table">
                    <thead>
                        <tr>
                            <th>Api Name</th>
                            <th>API Instance</th>
                            <th>SLA Tier</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        { groupApisByInstanceGroup(currentApplication?.apis)?.map((api, index) => {
                                const hasPendingChange = api.pendingSlaTierId && api.contractStatus?.toLowerCase() === 'approved';
                                return (
                                    <React.Fragment key={index}>
                                        <tr className={hasPendingChange ? 'has-pending-change' : ''}>
                                            <td>
                                                <hbr-tooltip size="small" content={api.apiName} trigger="hover" placement="top" class="atm-tooltip--small">
                                                    <span className='api-name'>{api.apiName}</span>
                                                    <span className='api-version'>{api.version}</span>
                                                </hbr-tooltip>
                                            </td>
                                            <td>{api.apiInstanceGroup || api.apiInstance}</td>
                                            <td>{api?.slaTier ? api.slaTier : "-"}</td>
                                            <td className="api-status">
                                                <RequestStatusBadge status={api.contractStatus} />
                                            </td>
                                            <td className="api-actions">
                                                {!hasPendingChange && (api.contractStatus?.toLowerCase() === 'approved' || api.contractStatus?.toLowerCase() === 'pending') && (
                                                    <Button className="action-icons mr-1" variant="text" onClick={() => openEditContractModal(currentApplication.id, api)}>
                                                        <i className="atm-icon draw"/>
                                                    </Button>
                                                )}
                                                {!hasPendingChange && (
                                                    <Button className="action-icons" variant="text" onClick={() => {
                                                        handleClose('apis');
                                                        setSelectedContract(api);
                                                        setAppIdForModal(currentApplication.id);
                                                        setShowModal(prev => ({ ...prev, deleteContract: true }));
                                                    }}>
                                                        <i className="atm-icon delete"/>
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                        {hasPendingChange && (
                                            <tr className="pending-tier-change-row">
                                                <td></td>
                                                <td></td>
                                                <td>{api.pendingSlaTier || '-'}</td>
                                                <td className="api-status">
                                                    <RequestStatusBadge status="PENDING" />
                                                </td>
                                                <td className="api-actions">
                                                    <Button className="action-icons" variant="text" onClick={() => {
                                                        handleClose('apis');
                                                        setSelectedContract(api);
                                                        setAppIdForModal(currentApplication.id);
                                                        setShowModal(prev => ({ ...prev, deleteContract: true }));
                                                    }}>
                                                        <i className="atm-icon delete"/>
                                                    </Button>
                                                </td>
                                            </tr>
                                        )}
                                </React.Fragment>
                                );
                            })}
                    </tbody>
                </table>
            ),
            footerButtons: [
                { text: 'Close', variant: 'primary', onClick: () => handleClose('apis') }
            ]
        },
        editContract: {
            title: 'Edit SLA Tier',
            body: 'Select the new SLA tier for this contract.',
            provideSlaTierSelect: true,
            slaTiersLoading: contractSlaTiersLoading,
            slaTiers: (contractSlaTiers || []).map(t => ({
                id: String(t.slaTierId),
                name: capitalize(t.slaTierName),
                limits: t.limits,
                status: t.status,
                autoApprove: t.autoApprove
            })),
            currentTierId: selectedContract?.slaTierId
                ? String(selectedContract.slaTierId)
                : (() => {
                    const match = (contractSlaTiers || []).find(t => 
                        t.slaTierName?.toLowerCase() === selectedContract?.slaTier?.toLowerCase()
                    );
                    return match ? String(match.slaTierId) : '';
                })(),
            excludeTierIds: (() => {
                const ids = [];
                if (selectedContract?.slaTierId) {
                    ids.push(String(selectedContract.slaTierId));
                }
                if (selectedContract?.approvedSlaTierId) {
                    ids.push(String(selectedContract.approvedSlaTierId));
                }
                return ids.length > 0 ? ids : undefined;
            })(),
            currentTierDisplay: (() => {
                const match = (contractSlaTiers || []).find(t => 
                    t.slaTierName?.toLowerCase() === selectedContract?.slaTier?.toLowerCase()
                );
                if (match && match.limits?.[0]) {
                    const limit = match.limits[0];
                    const keys = Object.keys(limit);
                    return `${capitalize(match.slaTierName)} (${limit[keys[0]]} requests per ${limit[keys[1]]} milliseconds)`;
                }
                return selectedContract?.slaTier ? capitalize(selectedContract.slaTier) : '-';
            })(),
            tierLabel: 'Current SLA Tier',
            provideDenialReason: true,
            reasonRequired: true,
            reasonLabel: 'Reason for Change',
            requestStatus: selectedContract?.contractStatus,
            confirmationStep: {
                header: 'Confirm Editing this Contract',
                message: 'Are you sure you want to edit this Contract?',
                okButtonLabel: 'Confirm',
                cancelButtonLabel: 'Cancel',
            },
            manualApprovalConfirmationStep: {
                header: 'Confirm editing this contract?',
                message: 'This change will require publisher approval. Your current SLA tier will remain active until approved.',
                okButtonLabel: 'Confirm',
                cancelButtonLabel: 'Cancel',
            },
            footerButtons: {
                cancel: { text: 'Cancel', variant: 'outline-secondary', onClick: () => handleClose('editContract') },
                ok: { text: 'Submit', variant: 'primary', onClick: handleEditContract }
            }
        },
        deleteContract: {
            title: 'Confirm Contract Removal',
            body: 'Are you sure you want to Remove this Contract?',
            footerButtons: {
                cancel: { text: 'Cancel', variant: 'outline-secondary', onClick: () => handleClose('deleteContract') },
                ok: { text: 'Remove', variant: 'danger', onClick: handleClientDeleteContract }
            }
        },
        owners: {
            title: 'Associated Owners',
            body: (
                <div>
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Owner CCO ID: </span>
                        <input
                            type="text"
                            placeholder="Add Owner by CCO ID"
                            className="mx-2"
                            style={{width: "250px"}}
                            value={newOwnerCcoId}
                            onChange={(e) => validateNewOwnerCcoId(e.target.value)}
                        />

                        <Button 
                            onClick={() => addOwnerToApplication(newOwnerCcoId)} 
                            type="button" 
                            className="action-icons btn btn-text"
                            disabled={!newOwnerCcoId}
                        >
                            +
                        </Button>
                    </div>
                    <div style={{height: "20px"}}>{ownerCcoIdError && <div className="text-danger small new-owner-error">{ownerCcoIdError}</div>}</div>

                    <table className="table mt-2 mb-5 associated-owner-table iap-table">
                        <thead>
                            <tr>
                                <th>Owner</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentApplication?.owners?.map((owner, index) => (
                                <tr key={index}>
                                    <td>
                                        <span className='owner-name'>{owner}</span>
                                    </td>
                                    <td>
                                                    {(window.sessionStorage.getItem("remoteUser") !== owner && primaryOwner !== owner) && (
                                            <Button onClick={(e) => {e.stopPropagation();removeOwnerFromApplication(owner)}} className="action-icons" variant="text" >
                                                <i className="atm-icon delete"/>
                                            </Button>
                                       )}  
                                    </td>
                                </tr>
                            ))}
                            {(!currentApplication?.owners || currentApplication.owners.length === 0) && (
                                <tr>
                                    <td colSpan="2" className="text-center">No owners found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div className='text-danger small'>{errorOnSaveOwners}</div>
                    <div className='text-success small'>{successOnSaveOwners}</div>
                </div>
            ),
            footerButtons: [
                { text: 'Save', variant: 'primary', onClick: () => {saveOwnersList()}, disabled: newAddedOwners.length === 0 },
                { text: 'Close', variant: 'secondary', onClick: () => handleClose('owners') }
            ]
        },
        deleteOwner: {
            title: 'Remove Owner',
            body: 'Are you sure you want to remove this owner permanently?',
            footerButtons: {
                cancel:{ text: 'Close', variant: 'secondary', onClick: () => handleClose('deleteOwner') },
                ok: { text: 'Yes, Remove', variant: 'danger', onClick: () => { deleteOwner(deleteId) } }
            }
        },
    };

    const handleCopyClick = async (text, index, type="") => {
        copyText(text);
        if (type == "reset") {
            setShowCopy(prev => ({ ...prev, [index]: false }));
            setTimeout(() => setShowCopy(prev => ({ ...prev, [type]: true })), 1500);
        } else if(type=="secret") {
            setShowCopyStatesSecret(prev => ({ ...prev, [index]: false }));
            setTimeout(() => setShowCopyStatesSecret(prev => ({ ...prev, [index]: true })), 1500);
        } else {
            setShowCopyStates(prev => ({ ...prev, [index]: false }));
            setTimeout(() => setShowCopyStates(prev => ({ ...prev, [index]: true })), 1500);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            dropdownRefs.current.forEach((ref, index) => {
                if (ref && !ref.contains(event.target)) {
                    setDropdownVisible(prevVisibility => {
                        const newVisibility = [...prevVisibility];
                        newVisibility[index] = false;
                        return newVisibility;
                    });
                }
            });
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const fetchOwners = (modal, appId) => {
    //     setLoading(true);
    //     props.dispatch(fetchOwnersList(appId));  
    // };

    const fetchOwners = (modal, appId) => {
        setLoading(true);
        props.dispatch(fetchOwnersList(appId, (data) => {
            // Support both legacy array response and new object response.
            if (Array.isArray(data)) {
                renderOwnersList(data, '');
                return;
            }

            const primaryOwnerFromApi = data?.primaryOwner || '';
            const additionalOwners = Array.isArray(data?.additionalOwners) ? data.additionalOwners : [];
            const combinedOwners = [primaryOwnerFromApi, ...additionalOwners].filter(Boolean);
            renderOwnersList(combinedOwners, primaryOwnerFromApi);
        }, handleError));
    };

    const renderOwnersList = (data, primaryOwnerFromApi = '') => {
        setLoading(false);
        setPrimaryOwner(primaryOwnerFromApi || '');
        if (data) {
            const ownersFromApi = data || [];
            const owners = ownersFromApi.length > 0 
                ? ownersFromApi 
                : (currentApplication?.owners && currentApplication.owners.length > 0 
                    ? currentApplication.owners : [] );
            setCurrentApplication(prevValue => ({
                ...prevValue, 
                owners: owners
            }));  
            setInitialOwners(owners);  
            setNewAddedOwners([]);
            setDeletedOwners([]);
            setDeleteId(null);
            setNewOwnerCcoId('');
            setOwnerCcoIdError('');
            setErrorOnSaveOwners('');
            setSuccessOnSaveOwners('');
            setShowModal(prev => ({ ...prev, owners: true }));
        }
    };

    const validateNewOwnerCcoId = (value) => {
        setNewOwnerCcoId(value);
        // if (value && value.length < 5) {
        //     setOwnerCcoIdError('CCO ID must be at least 5 characters');
        // } 
        // else if (value && !/^[a-zA-Z]+$/.test(value)) {
        //     setOwnerCcoIdError('CCO ID should only contain letters');
        // } 
        // else {
        //     setOwnerCcoIdError('');
        // }
        setOwnerCcoIdError('');
    };

    const addOwnerToApplication = (ownerCcoId) => {
        const ownerExistsInApp = currentApplication?.owners?.includes(ownerCcoId);
        const ownerExistsInNewAdded = newAddedOwners.includes(ownerCcoId);

        if (ownerExistsInApp || ownerExistsInNewAdded) {
            setOwnerCcoIdError('This CCO ID is already added as an owner');
            return;
        }
        setCurrentApplication(prevApp => ({
            ...prevApp,
            owners: [...(prevApp.owners || []), ownerCcoId]
        }));
        setNewAddedOwners(prev => [...prev, ownerCcoId]);
        setNewOwnerCcoId('');
        setOwnerCcoIdError(''); 
    };

    const removeOwnerFromApplication = (ownerCcoId) => {
        const ownerExistsInInitial = initialOwners?.includes(ownerCcoId);
        const ownerExistsInNewAdded = newAddedOwners.includes(ownerCcoId);
        
        if (ownerExistsInNewAdded) {
            setCurrentApplication(prevApp => ({
                ...prevApp,
                owners: (prevApp.owners || []).filter(owner => owner !== ownerCcoId)
            }));
            setNewAddedOwners(prev => prev.filter(owner => owner !== ownerCcoId));
        }
        if (ownerExistsInInitial) {
            handleShowModal('deleteOwner', ownerCcoId)
        }
    };

    const deleteOwner = (ownerCcoId) => {
        setLoading(true);
        const ownersToDelete = [ownerCcoId];
        setDeletedOwners(ownersToDelete);
        props.dispatch(removeOwner(currentApplication.id, ownersToDelete, confirmRemoveOwner, handleError));
    }

    const confirmRemoveOwner = (data) => {
        if (data) {
            setLoading(false);
            setInitialOwners(prev => prev.filter(owner => owner !== deleteId));
            setCurrentApplication(prevApp => ({
                ...prevApp,
                owners: (prevApp.owners || []).filter(owner => owner !== deleteId)
            }));
            setDeletedOwners([]);
            handleClose('deleteOwner');
            setErrorOnSaveOwners('');
            setSuccessOnSaveOwners('Owner deleted successfully!');
            // showToast({
            //     title: 'Operation Successful',
            //     bg: 'success',
            //     message: 'Owner deleted successfully!',
            // });
        }
    };

    const saveOwnersList = () => {
        if(newAddedOwners.length > 0) {
            setLoading(true);
            setSuccessOnSaveOwners('');
            setErrorOnSaveOwners('')
            props.dispatch(addOwner(currentApplication.id, newAddedOwners, confirmAddOwners, handleAddError));
        }
    };

    const confirmAddOwners = (data) => {
        if (data) {
            setLoading(false);
            handleClose('owners');
            setNewAddedOwners([]);
            setErrorOnSaveOwners('');
            setSuccessOnSaveOwners('');
            showToast({
                title: 'Operation Successful',
                bg: 'success',
                message: 'Owner(s) added successfully!',
            });
        }
    };

    const handleAddError = (errorMessage) => {
        setLoading(false);
        if (errorMessage.error.length > 0) {
            setSuccessOnSaveOwners('');
            setErrorOnSaveOwners(errorMessage.error);
            // showToast({
            //     title: 'Operation Failed',
            //     bg: 'danger',
            //     message: errorMessage.error,
            // });
        } else {
            setSuccessOnSaveOwners('');
            setErrorOnSaveOwners("Operation Failed");
            // showToast({
            //     title: 'Operation Failed',
            //     bg: 'danger',
            //     message: "Operation Failed",
            // });
        }
    }

    const handleError = (errorMessage) => {
        setLoading(false);
        if (errorMessage.error.length > 0) {
            // setError(errorMessage.error);
            setSuccessOnSaveOwners('');
            setErrorOnSaveOwners(errorMessage.error);
            // showToast({
            //     title: 'Operation Failed',
            //     bg: 'danger',
            //     message: errorMessage.error,
            // });
        } else {
            // setError("Operation Failed");
            setSuccessOnSaveOwners('');
            setErrorOnSaveOwners("Operation Failed");
            // showToast({
            //     title: 'Operation Failed',
            //     bg: 'danger',
            //     message: "Operation Failed",
            // });
        }
    }

    function groupApisByInstanceGroup(apis) {
        if (!apis || !apis.length) return [];
        const grouped = {};
        const ungrouped = [];
        apis.forEach(api => {
            const group = api.apiInstanceGroup;
            if (!group) {
                ungrouped.push(api);
                return;
            }
            if (!grouped[group]) {
                grouped[group] = { ...api };
            } else {
                grouped[group].apiInstance = `${grouped[group].apiInstance}, ${api.apiInstance}`;
                if (grouped[group].apiInstanceId && api.apiInstanceId) {
                    grouped[group].apiInstanceId = `${grouped[group].apiInstanceId}, ${api.apiInstanceId}`;
                }
            }
        });
        return [...Object.values(grouped), ...ungrouped];
    }

    const renderAPIContent = () => {
        currentApplication.apis = currentApplication.apis ?? [];
        const groupedApis = groupApisByInstanceGroup(currentApplication.apis);
        const apis = groupedApis.length < 3 ? groupedApis : groupedApis.slice(0, 2);
        if(!apis.length) return 'No APIs Associated';
        return (
            <>
                {
                    apis.map(api => (
                        <div key={api.apiName} className='api-list-container'>
                            <span>{api.apiName}</span>
                            <span className='api-version'>{api.version}</span>
                            <span>{api.apiInstanceGroup || api.apiInstance}</span>
                            <RequestStatusBadge status={api.contractStatus} />
                        </div>
                    ))
                }
                {currentApplication.apis.length > 0 && <span className='toggle-button' onClick={()=>handleShowModal('apis', currentApplication.id)}>Show all APIs and Status</span>}
            </>
        )
    }

    const renderTable = () => (
        <>
        <div className="search-container my-3">
        <input
            type="text"
            placeholder="Search for your Application by name"
            value={searchTerm}
            onChange={handleSearchTermChange}
            onKeyUp={handleKeyPress}
            className="search-input"
        />
        <i class="atm-icon search search-icon" onClick={handleSearch}/>
    </div>

    <>
        <table className="pubhub-table iap-table">
            <thead>
                <tr>
                    <th></th>
                    <th>Application Name</th>
                    <th>Client ID</th>
                    <th>Client Secret</th>
                    <th>Registered APIs</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {!loading && applications.length === 0 && (
                    <tr>
                        <td colSpan="7">
                            <div className='text-center empty-state'>
                                <img
                                    src="https://www.cisco.com/c/dam/cdc/ui/atm/1-5-0/images/illustrations/empty-state/no-results-light-large.svg"
                                    alt="Empty state illustration"
                                    width="240px"
                                    height="160px"
                                />
                                <p className='text-center mb-0'>No Records found</p>
                            </div>
                        </td>
                    </tr>
                )}
                {applications && applications.length > 0 && applications.map((application, index) => (
                    <React.Fragment key={index}>
                        <tr>
                            <td>
                                <div onClick={() => { toggleRow(index, application.id) }}>
                                    <i class={`atm-icon chevron-${expandedRow === index ? 'down' : 'right'}`}/>
                                </div>
                            </td>
                            <td>{application.name}</td>
                            <td>
                                {application.clientId}

                                {showCopyStates[index] 
                                    ? <i className="ps-3 atm-icon clone cursor" onClick={() => handleCopyClick(application.clientId, index)}></i> 
                                    : <i className="ps-3 bi bi-check-lg green"></i>}

                            </td>
                             <td>
                                { application.clientSecret && application.clientSecret.trim() && (
                                    <span className={`semi-bold-black ${hiddenStates[index] ? 'hide-content' : 'elipsis'}`}>{application.clientSecret}</span>
                                )}
                                { !application.clientSecret && (
                                    <span className={`semi-bold-black elipsis`}>---</span>
                                )}
                                { application.clientSecret && application.clientSecret.trim() && (
                                    <div>
                                        {showCopyStatesSecret[index]
                                            ? <i className="ps-3 atm-icon clone cursor" onClick={() => handleCopyClick(application.clientSecret, index, "secret")}></i>
                                            : <i className="ps-3 bi bi-check-lg green"></i>}
                                        {hiddenStates[index]
                                            ? <i className="me-2 ps-2 atm-icon eye" onClick={() => toggleClass(index)}></i>
                                            : <i className="me-2 ps-2 atm-icon eye-closed" onClick={() => toggleClass(index)}></i>
                                        }
                                    </div>
                                )}
                            </td> 
                            <td>{application.registeredApiCount}</td>
                            <td>
                                <Button className="action-icons me-1" variant="text" data-toggle="modal" data-target="#exampleModal" onClick={() => handleShowModal('edit', application.id)}>
                                    <i class="atm-icon draw"/>
                                </Button>
                                <Button className="action-icons" variant="text" onClick={() => handleShowModal('delete', application.id)}>
                                    <i class="atm-icon delete"/>
                                </Button>
                                {/* <span className='pl-1' style={{ position: 'relative', cursor: 'pointer' }}><i className="bi bi-three-dots-vertical" onClick={() => toggleDropdown(index)}></i>
                                    {dropdownVisible[index] && (
                                        <div className="dropdown-menu" ref={el => dropdownRefs.current[index] = el}>
                                            <a className="dropdown-item" onClick={() => { handleShowModal('reset', application.id); dropdownVisible[index] = false }}>Reset Client Secret</a>
                                        </div>
                                    )}
                                </span> */}
                            </td>
                        </tr>
                        {expandedRow === index && (
                            <tr>
                                <td colSpan="7" className="expanded-row">
                                    <div className='expanded-row-container'>
                                        <div className='top-row row'>
                                            <div className='col-details col-4'>
                                                <span className='expanded-row-label'>Client ID</span>
                                                <span className='expanded-row-content semi-bold-black client-id'>{application.clientId}</span>
                                                <span className='expanded-row-action'>
                                                    <CopyTexttoClipBrd textToCopy={application.clientId} />
                                                </span>
                                            </div>
                                            <div className='col-details  col-5'>
                                                <span className='expanded-row-label'>Client Secret</span>
                                                { application.clientSecret && application.clientSecret.trim() && (
                                                    <span className={`expanded-row-content semi-bold-black ${hiddenStates[index] ? 'hide-content' : 'elipsis'}`}>{application.clientSecret}</span>
                                                )}
                                                { !application.clientSecret && (
                                                    <span className={`expanded-row-content semi-bold-black elipsis`}>---</span>
                                                )}
                                                { application.clientSecret && application.clientSecret.trim() && (
                                                    <span className='expanded-row-action'>
                                                        {hiddenStates[index]
                                                            ? <i className="me-2 ps-2 atm-icon eye" onClick={() => toggleClass(index)}></i>
                                                            : <i className="me-2 ps-2 atm-icon eye-closed" onClick={() => toggleClass(index)}></i>
                                                        }
                                                        <CopyTexttoClipBrd textToCopy={application.clientSecret} />
                                                    </span>
                                                )}
                                            </div>
                                            <div className='col-details col-3'>
                                                { !( application.grantTypes.length == 2 && 
                                                    application.grantTypes.includes("authorization_code_pkce") && 
                                                    application.grantTypes.includes("refresh_token") ) && 
                                                    application.gateway?.toUpperCase() !== 'NG_MASHERY' && (
                                                    <span className="row-expend-link" onClick={() => handleShowModal('reset', application.id)}>
                                                        Reset Client Secret
                                                        <i class="atm-icon animation ms-1"/>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className='row bottom-row'>
                                            <div className='col-4 api-section'>
                                                <span className='expanded-row-label'>Description</span>
                                                <span className='expanded-row-content'>{application.description || '-'}</span>
                                                <span className='expanded-row-label mt-2'>Grant Types</span>
                                                <span className='expanded-row-content'>{(application.grantTypes || []).map(type => getPropTypeLabel(type))?.join(', ')}</span>
                                                <span className='toggle-button' onClick={()=>fetchOwners('owners', application.id)}>Manage Owners</span>
                                            </div>
                                            <div className='col-4 api-section'>
                                                <span className='expanded-row-label'>Application URL:</span>
                                                <span className='expanded-row-content'>{application.url || '-'}</span>
                                                <span className='expanded-row-label mt-2'>Redirect URI:</span>
                                                <span className='expanded-row-content'>{(application.redirectUri || []).join(', ')}</span>
                                            </div>
                                            <div className='col-4 api-section'>
                                                <span className='expanded-row-label'>APIs</span>
                                                <div className='expanded-row-content'>
                                                    {renderAPIContent()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </table>
        <TablePaginationNew
            tableConfig={tableConfig}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
        />
    </>
    </>
    )
    return (
        <>
            <EditOrCreateApplication 
                className='custom-width-540'
                show={showModal.edit} 
                showAlert={popupData.showAlert} 
                title={popupData.title} 
                status={popupData.status} 
                message={popupData.message} 
                type={'Edit'} data={formValues} 
                onSubmit={(updatedData) => updateApplication(currentApplication.id, currentApplication.gateway, currentApplication.authType, updatedData)} 
                onClose={() => handleClose('edit')} 
            />

            {Object.keys(modals).map((key) => (
                <>
                    {key === 'apis' && (
                        <Modal show={showModal[key]} centered="true" onHide={() => handleClose(key)} className='app-modal-popup custom-width-750' backdrop='static'>
                            <Modal.Header closeButton>
                                <Modal.Title>{modals[key].title}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{modals[key].body}</Modal.Body>
                            <Modal.Footer>
                                {modals[key].footerButtons.map((button, index) => (
                                    <Button key={index} variant={button.variant} onClick={button.onClick}>
                                        {button.text}
                                    </Button>
                                ))}
                            </Modal.Footer>
                        </Modal>
                    )}
                    
                    {key === 'owners' && (
                        <Modal show={showModal[key]} centered="true" onHide={() => handleClose(key)} className='app-modal-popup custom-width-450' backdrop='static'>
                            <Modal.Header closeButton>
                                <Modal.Title>{modals[key].title}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>{modals[key].body}</Modal.Body>
                            <Modal.Footer>
                                {modals[key].footerButtons.map((button, index) => (
                                    <Button disabled={button.disabled} key={index} variant={button.variant} onClick={button.onClick}>
                                        {button.text}
                                    </Button>
                                ))}
                            </Modal.Footer>
                        </Modal>
                    )}

                    {key !== 'apis' && key !== 'owners' && (
                        <CommonConfiramation
                            key={key}
                            show={showModal[key]}
                            onClose={() => handleClose(key)}
                            popupConfig={{
                                header: modals[key].title,
                                message: modals[key].body,
                                okButtonLabel: modals[key].footerButtons.ok?.text,
                                cancelbuttonLabel: modals[key].footerButtons.cancel?.text,
                                showCancel: !!modals[key].footerButtons.cancel,
                                cancelVariant: modals[key].footerButtons.cancel?.variant,
                                sentiment: modals[key].footerButtons.ok?.variant,
                                data: modals[key].data,
                                ...(modals[key].provideSlaTierSelect && {
                                    provideSlaTierSelect: true,
                                    slaTiersLoading: modals[key].slaTiersLoading,
                                    slaTiers: modals[key].slaTiers,
                                    currentTierId: modals[key].currentTierId,
                                    excludeTierIds: modals[key].excludeTierIds,
                                    currentTierDisplay: modals[key].currentTierDisplay,
                                    tierLabel: modals[key].tierLabel,
                                    requestStatus: modals[key].requestStatus,
                                }),
                                ...(modals[key].provideDenialReason && {
                                    provideDenialReason: true,
                                    reasonRequired: modals[key].reasonRequired,
                                    reasonLabel: modals[key].reasonLabel,
                                }),
                                ...(modals[key].confirmationStep && {
                                    confirmationStep: modals[key].confirmationStep,
                                }),
                                ...(modals[key].manualApprovalConfirmationStep && {
                                    manualApprovalConfirmationStep: modals[key].manualApprovalConfirmationStep,
                                }),
                            }}
                            onCancel={modals[key].footerButtons.cancel?.onClick}
                            onSubmit={modals[key].footerButtons.ok?.onClick}
                            {...((key === 'editContract' || key === 'deleteContract') && { onBack: handleBackToApis })}
                        />
                    )}
                </>
            ))}

           
            <div className={`mb-3 px-${config ? 4 : 5} pt-3 myappsTable`} id="pubhub-widgets">
                {loading && !error && <Loader />}
                <h3 className='pubhub-page-title mt-0 mb-4'>My Applications</h3>
                {config ? (
                    <>
                        {renderTable()}
                    </>

                ) :
                    <hbr-tab-group primary>
                        <hbr-tab slot="nav" panel="managed" active={true}>
                            Managed Credentials
                        </hbr-tab>
                        <hbr-tab slot="nav" panel="unmanaged">
                            Unmanaged Credentials
                        </hbr-tab>
                        <hbr-tab-panel name="managed">
                            <hbr-banner
                                closable="false"
                                icon="status-info-outline"
                                sentiment="info"
                                open="true"
                            >
                                These credentials are directly managed by the IT API Portal to access the APIs.
                                <i slot="icon" class="atm-icon status-info"></i>
                            </hbr-banner>
                            {renderTable()}
                        </hbr-tab-panel>
                        <hbr-tab-panel name="unmanaged">
                            <hbr-banner
                                closable="false"
                                icon="status-info-outline"
                                sentiment="info"
                                open="true"
                            >
                                Unmanaged credentials are handled by external platforms. Click the links below to manage them directly on their respective portals.                                
                                <i slot="icon" class="atm-icon status-info"></i>
                            </hbr-banner>
                            <div className='d-flex mt-5 gateway-container'>
                                {otherGateways.map(gateway => (
                                    <div className='gateway-wrapper'>
                                        <a href={gateway.url} target="_blank" rel="noopener noreferrer">
                                            <div class="box d-flex flex-column align-items-center">
                                                <div className={`gateway-img  mb-3 ${gateway.ref.toLowerCase()}`} ></div>
                                                <div className='title'>{gateway.title}</div>
                                            </div>
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </hbr-tab-panel>
                    </hbr-tab-group>

                }

            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        loader: state.request.isLoading,
        //errorResponse: state.request.errorResponse,
        response: state.request.response,
        deleteResponse: state.request.deleteResponse,
        resetResponse: state.request.resetResponse,
        applicationList: state.request.applicationList,
        applicationDetail: state.request.applicationDetail,
        refetchApplication: state.request.refetchApplication,
        errorResponseApps: state.request.errorResponseApps,
        ownersList: state.request.ownersList,
        addOwner: state.request.addOwner,
        removeOwner: state.request.removeOwner,
    }
}

export default connect(mapStateToProps)(MyApps);